import React from 'react';
import { RxDashboard } from 'react-icons/rx';

const ShopManagementPageHero = ({ eyebrow = 'Shop Tools', title, copy }) => {
  return (
    <header className="shop-management-page-hero">
      <div>
        <p className="shop-management-page-eyebrow">{eyebrow}</p>
        <h1>{title}</h1>
        {copy && <p className="shop-management-page-copy">{copy}</p>}
      </div>
      <div className="shop-management-page-hero-icon" aria-hidden="true">
        <RxDashboard />
      </div>
    </header>
  );
};

export default ShopManagementPageHero;